import type { State } from '../configureStore'
import { Filter as ActionTypes } from '../actionTypes'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import type { FilterAccount } from '../reducers/filter'

// Action Creators
export type ActionTypes = applyNowAction | resetAllAction

export interface ApplyNowOptions {
  currentAccount: FilterAccount
}

const applyNow = (options: ApplyNowOptions) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.APPLY_NOW, {
    options
  })
type applyNowAction = ReturnType<typeof applyNow>

const resetAll = () => ReduxHelpers.Actions.createAction(ActionTypes.RESET_ALL)

type resetAllAction = ReturnType<typeof resetAll>

export function updateFilter(
  { currentAccount }: ApplyNowOptions,
  callback: () => void
) {
  return (dispatch: any, getState: () => State) => {
    dispatch(applyNow({ currentAccount }))
    if (callback) callback()
  }
}

export function resetFilter(callback?: () => void) {
  return (dispatch: any, getState: () => State) => {
    dispatch(resetAll())
    if (callback) callback()
  }
}
